'use strict';

/**
 * Checks if two arrays have any common elements.
 *
 * @param a - The first array.
 * @param b - The second array.
 * @returns `true` if the arrays have at least one common element, `false` otherwise.
 */ function hasIntersection(a, b) {
    return !!a.find((v)=>b.includes(v));
}

module.exports = hasIntersection;
